import DeliveryModel from './delivery.model'
import SimModel from './sim.model'
import BaseModel from './base.model';

export default class CartModel extends BaseModel {

  sims = [];
  current_sim = null;
  delivery = null;    
  promo_code = null;
  checkout_status = null;
  current_step = 0;

  constructor (data) {
    super();

    var self = this;
    if (self.isEmpty(data)) return self;
    
    self.sims = [];
    data.sims.forEach(function (value) {
      self.sims.push(new SimModel(value));
    });
    
    self.current_sim = new SimModel(data.current_sim);
    self.delivery = new DeliveryModel(data.delivery);
    self.promo_code = data.promo_code;
    self.checkout_status = data.checkout_status;
    self.current_step = data.current_step;
  }
}
